import getProbeSensorTypes from '../../../util/get-probe-sensor-types'

const CalibrationOffset = sensor => {

  const probeSensorTypes = getProbeSensorTypes();

  let html = `
  
  <div class="setting">
        
    <h3>Sensor Data Calibration</h3>

      <div class="setting__input">
        
        <div class="setting__switch">
          <div class="setting__switch__value">
            <div class="switch medium">
              <input class="switch-input" type="checkbox" id="use_offset" name="use_offset" value="1" ${sensor.use_offset == 1 ? 'checked' : ''} />
              <label class="switch-paddle" for="use_offset">
                <span class="switch-active">On</span>
                <span class="switch-inactive">Off</span>
              </label>
            </div>
          </div>
          <div class="setting__switch__label">Add an offset to your temperature or humidity readings</div>
        </div>

      </div>
    </div>
    
    <div class="setting setting--conditional ${sensor.use_offset == 1 ? 'is-active' : ''}" data-for="use_offset">
    
      <div class="setting__description">Offset the sensor reading +/- 10 max</div>
    
      <div class="setting_label">Temperature Offset</div>
      <div class="setting__value setting__value--range">
      
        <div class="setting__value__range">
          <input type="range" min="-10" max="10" value="${sensor.temp_offset}" step="0.1" name="temp_offset" />
        </div>
        <div class="setting__value__label" data-for="temp_offset">${sensor.temp_offset}&deg;${window.currentUser.temp_pref}</div>
        
      </div>
      
      <div class="setting_label">Humidity Offset</div>
      <div class="setting__value setting__value--range">
      
        <div class="setting__value__range">
          <input type="range" min="-10" max="10" value="${sensor.humidity_offset}" step="0.1" name="humidity_offset" />
        </div>
        <div class="setting__value__label" data-for="humidity_offset">${sensor.humidity_offset}%</div>
        
      </div>
      
      ${probeSensorTypes[sensor.type] ? `
        <p class="text--bold c-margin-xsm c-margin-top-sm">Thermocouple Probe</p>
        <div class="setting_label">Probe Temp Offset</div>
        <div class="setting__value setting__value--range">
        
          <div class="setting__value__range">
            <input type="range" min="-10" max="10" value="${sensor.probe_temp_offset}" step="0.1" name="probe_temp_offset" />
          </div>
          <div class="setting__value__label" data-for="probe_temp_offset">
            ${sensor.probe_temp_offset}&deg;${window.currentUser.temp_pref}
          </div>
          
        </div>
      ` : ''}
      
    </div>
  `;

  return html;

}

export default CalibrationOffset;
